import React, { useEffect, useState } from "react";
import DTOResetPassword from "./DTOResetPassword";
import ResetPasswordPresenter from "./ResetPasswordPresenter";

const ResetPasswordController = () => {
  return (
    <div>
      <DTOResetPassword />
      <ResetPasswordPresenter />
    </div>
  );
};

export default ResetPasswordController;
